import {applyMiddleware, createStore, compose} from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import reducers from '../reducers';
import middlewares from '../middlewares';

export default (initialState) => {
  const createStoreWithMiddleware = compose(
    applyMiddleware(thunk,logger, ...middlewares),
  )(createStore);

  const store = createStoreWithMiddleware(
    reducers,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );

  return store;
};
